import React, { useState } from "react";
import { TaxPurposeType } from "src/api/billingSchedule/billing-type";
import { BaseButton } from "src/components/BaseButton";
import { BaseRadio } from "src/components/BaseRadio";

type Props = {
  onClose: () => void;
  onSubmit: (request: TaxPurposeType) => void;
  taxPurposeType: TaxPurposeType;
};

const BillTaxPurposeModal = ({ onClose, onSubmit, taxPurposeType }: Props) => {
  const [checkedTaxPurposeType, setCheckedTaxPurposeType] = useState<TaxPurposeType>(taxPurposeType);

  return (
    <>
      <section className="base-abstract-modal__title border-bottom-gray mb20 ">
        <div className="flex-direction-column">
          <h1>발행 유형</h1>
        </div>
      </section>
      <div className="px30">
        <section className="contents-container__grid">
          <div className="contents-container__grid-index">
            <p>계산서 발행 유형</p>
          </div>
          <div className="contents-container__grid-contents minmax240">
            <div className="flex-center-start flex-row">
              <BaseRadio
                id="billing"
                label="청구"
                value="billing"
                className="mr10"
                checked={checkedTaxPurposeType === "BILLING"}
                onChange={() => {
                  setCheckedTaxPurposeType("BILLING");
                }}
                name={""}
              />
              <BaseRadio
                id="receipt"
                label="영수"
                value="receipt"
                checked={checkedTaxPurposeType === "RECEIPT"}
                onChange={() => {
                  setCheckedTaxPurposeType("RECEIPT");
                }}
                name={""}
              />
            </div>
          </div>
        </section>
      </div>

      <section className="base-abstract-modal__btn-wrap">
        <BaseButton className="color-white" title="취소" onClick={onClose} />
        <BaseButton
          title="확인"
          onClick={() => {
            onSubmit(checkedTaxPurposeType);
            onClose();
          }}
        />
      </section>
    </>
  );
};

export default BillTaxPurposeModal;
